import React, { Component } from 'react'
import Layout from '../components/Layout'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  root: {
    height: 'calc(100% - 64px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

class NotPermission extends Component {
  render() {
    const { classes } = this.props
    return (
      <Layout>
        <div className={classes.root}>
          Você não tem as permissões necessárias para acessar esta funcionalidade.
        </div>
      </Layout>
    )
  }
}

export default withStyles(styles)(NotPermission)



// WEBPACK FOOTER //
// ./src/containers/NotPermission.js